import { InjectionToken } from '@angular/core';
import { Changelog } from '@vmspdb/definitions';
import { Observable } from 'rxjs';

export interface IChangelogService {
  changelog$(): Observable<Changelog>;
}

export const CHANGELOG = new InjectionToken<IChangelogService>(
  'vmspdf changelog',
);
